import { apiClient } from './client';

export const handleStorageClear = () => {
  localStorage.removeItem('auth');
  localStorage.removeItem('refresh');
};

export const logout = async () => {
  const res = await apiClient(`${process.env.REACT_APP_API_URL}common/o/revoke_token/`, {
    method: 'POST',
    body: JSON.stringify({
      token: localStorage.getItem('auth'),
      client_id: process.env.REACT_APP_CLIENT_ID
    })
  });

  localStorage.clear();
  window.dispatchEvent(new Event('storage'));

  return res;
};

export const login = async ({ username, password }) => {
  const res = await apiClient(`${process.env.REACT_APP_API_URL}common/o/token/`, {
    method: 'POST',
    body: JSON.stringify({
      username: username,
      password: password,
      grant_type: 'password',
      client_id: process.env.REACT_APP_CLIENT_ID
    })
  });

  return res.json();
};
